import { AppDialog } from '../AppDialog'
import { AppSnackbar } from '../AppSnackbar'

export const FeatureDialog: React.VFC = () => {
    return (
        <>
            <AppDialog />
            <AppSnackbar />
        </>
    )
}
